import React from "react";

const BusinessProfile = () => {
    return <div>BusinessProfile</div>;
};

export default BusinessProfile;
